var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiphy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 2 16.32 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.331 4.286H17.99v15.428H6.33z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3.714h2.331v16.572H4z",
    fill: "#04ff8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 8.286h2.331v12h-2.331z",
    fill: "#8e2eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.714h16.32V22H4z",
    fill: "#00c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2h9.326v2.286H4z",
    fill: "#fff152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 6.571V4.286h-2.332V2h-2.331v6.857h6.994V6.571",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 11.143V8.857h2.331",
    fill: "#551c99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.326 2v2.286h-2.332",
    fill: "#999131"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI1MDAiIHdpZHRoPSIyNTAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjQgMiAxNi4zMiAyMCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNi4zMzEgNC4yODZIMTcuOTl2MTUuNDI4SDYuMzN6IiBmaWxsPSIjMDAwIi8+PGcgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNNCAzLjcxNGgyLjMzMXYxNi41NzJINHoiIGZpbGw9IiMwNGZmOGUiLz48cGF0aCBkPSJNMTcuOTg5IDguMjg2aDIuMzMxdjEyaC0yLjMzMXoiIGZpbGw9IiM4ZTJlZmYiLz48cGF0aCBkPSJNNCAxOS43MTRoMTYuMzJWMjJINHoiIGZpbGw9IiMwMGM1ZmYiLz48cGF0aCBkPSJNNCAyaDkuMzI2djIuMjg2SDR6IiBmaWxsPSIjZmZmMTUyIi8+PHBhdGggZD0iTTE3Ljk4OSA2LjU3MVY0LjI4NmgtMi4zMzJWMmgtMi4zMzF2Ni44NTdoNi45OTRWNi41NzEiIGZpbGw9IiNmZjViNWIiLz48cGF0aCBkPSJNMTcuOTg5IDExLjE0M1Y4Ljg1N2gyLjMzMSIgZmlsbD0iIzU1MWM5OSIvPjwvZz48cGF0aCBkPSJNMTMuMzI2IDJ2Mi4yODZoLTIuMzMyIiBmaWxsPSIjOTk5MTMxIi8+PC9nPjwvc3ZnPg==";
export { SvgGiphy as ReactComponent };